/* ──────────────────────────────
   store/country/reducer.js
   ────────────────────────────── */

import {
  GET_COUNTRIES,
  UPDATE_COUNTRY_STATUS,
} from "./types";

const initialState = {
  countries: [],
  totalCountries: 0,
};

const countryReducer = (state = initialState, action) => {
  switch (action.type) {

    /* ─────────── list ─────────── */
    case GET_COUNTRIES:
      return {
        ...state,
        countries: action.payload.countries,
        totalCountries: action.payload.total,
      };

    /* ─────────── toggle status ─────────── */
    case UPDATE_COUNTRY_STATUS:
      return {
        ...state,
        countries: state.countries.map((c) =>
          c._id === action.payload._id ? action.payload : c
        ),
      };

    default:
      return state;
  }
};

export default countryReducer;
